import React, { useEffect, useState } from 'react';
import { CATEGORY_DESCRIPTION_SECTIONS } from '../../constants/sectionConfig';
import { useTranslation } from 'react-i18next';

interface Props {
  status: Record<string, string>;
  generatedContent: Record<string, string | null>;
}

const StreamingContainer: React.FC<Props> = ({ status, generatedContent }) => {
  const { t } = useTranslation();
  const [progress, setProgress] = useState<Record<string, number>>({});

  useEffect(() => {
    const newProgress: Record<string, number> = {};
    Object.keys(generatedContent).forEach((sectionId) => {
      const length = generatedContent[sectionId]?.length || 0;
      newProgress[sectionId] = length;
    });
    setProgress(newProgress);
  }, [generatedContent, status]);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-xl w-full max-w-4xl mx-4 max-h-[90vh] overflow-y-auto">
        <div className="space-y-4">
          {Object.entries(CATEGORY_DESCRIPTION_SECTIONS)
            .filter(([sectionId]) => sectionId in generatedContent)
            .map(([sectionId, config]) => {
              return (
                <div key={sectionId} className="border rounded-lg dark:border-gray-700">
                  <div className="border-b dark:border-gray-700 p-4 bg-gray-50 dark:bg-gray-750">
                    <div className="flex items-center justify-between mb-2">
                      <h3 className="font-medium text-gray-700 dark:text-gray-300">
                        {t(config.label)}
                      </h3>
                      <div className="flex items-center space-x-4">
                        <div className="px-2 py-1 bg-blue-100 dark:bg-blue-900 rounded-full">
                          <span className="text-xs font-medium text-blue-800 dark:text-blue-200">
                            {progress[sectionId] || 0} chars
                          </span>
                        </div>
                        <div className="text-sm text-gray-600 dark:text-gray-400">
                          {status[sectionId] || 'Waiting...'}
                        </div>
                      </div>
                    </div>
                    <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-1.5">
                      <div
                        className="bg-blue-500 h-1.5 rounded-full transition-all duration-300"
                        style={{
                          width: `${status[sectionId] === 'completed' ? 100 : progress[sectionId] > 95 ? 95 : progress[sectionId] || 0}%`, // Progress is now directly in percentage
                        }}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default StreamingContainer;
